<template>
<div>
  <!-- <v-card v-if="false" class="card fill-height">
    <v-card-title>
      <span class="font-weight-light text-truncate">
        <span v-text="item.id"></span> {{ item.name }}
      </span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      Available Inventory {{item.available}},
      {{item.lots + ' '}} lots 
      {{item.price}}/{{item.unit}} 
      <v-card-actions >
        <button  @click="addToCart(item)">Add to Cart</button>
      </v-card-actions>
    </v-card-text>
  </v-card> -->
  <v-card flat class="card item card-outer"  hover>
    <div class="shop">
      <v-layout row>
        <v-flex xs8>
          <h3>{{item.name }}</h3>
          <p style="margin-top: 3px;"> Available Inventory {{ item.available }}, 
            {{item.lots + ' '}} lots
          <br><span style="font-style: italic">Price: ${{ ' '+item.price+' '}}/{{' '+item.unit}}</span></p>
        </v-flex>
        <v-flex xs4 >
          <div class="text-xs-center">
            <v-tooltip left>
              <template v-slot:activator="{on, attrs}">
                <v-img
                  :src="srcImage"
                  :height="height-20+'px'"
                  contain
                  v-bind="attrs"
                  v-on="on"
                ></v-img>
              </template>
              <v-img
                v-if="srcImage != null"
                :src="srcImage"
                width="300px"
                height="100%"
              />
            </v-tooltip>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <v-card-actions >
      <button class="addbutton" @click="addToCart(item)">Add to Cart</button>
    </v-card-actions>
  </v-card>
  </div>
</template>
<script>
import axiosInstances from "@/../../coreui/server/axiosInstances"
import { sync } from "vuex-pathify"
export default {
  props: ['item', 'height', 'extra'],
  data () {
    return {
      image: null
    }
  },
  computed: {
    user: sync('login/loggedinUser'),
    srcImage () {
      return this.image
    }
  },
  methods: {
    addToCart(item) {
      console.log(item)
      this.$root.$emit("itemtocart", {item: item})
    },
    async getImage (id) {
      let self = this
      console.log(id)
      let res = await axiosInstances.apiServer.get(
          "/dt/v1/fac_inventory/" + id
        )
      if (res == null || res.data == null) return
      console.log(res)
      var url ="/getfiles/" +self.user.org +"/" +res.data.name+".png?subdir=fac_products";
      try {
        let img = await axiosInstances.apiServer.get(url, {
          responseType: "arraybuffer",
        });

        var bytes = new Uint8Array(img.data);
        var binary = bytes.reduce(
          (data, b) => (data += String.fromCharCode(b)),
          ""
        );
        var imgsrc = btoa(binary);
        if (imgsrc != null && imgsrc != "") {
          // console.log(imgsrc)
          self.image = "data:image/png;base64," + imgsrc;
        }
      } catch {}
    }
  },
  mounted () {
    this.getImage(this.item._id)
    // this.images = this.extra
    console.log(this.extra, this.height)
  }
}
</script>
<style scoped>
.v-tooltip__content.menuable__content__active {
  opacity: 1 !important;
}
.addbutton {
  margin-left: -5px;
  padding: 5px;
  border: 1px;
  background: green;
  transition: all 0.1s ease-out;
  border-radius: 5px;
  color: white;
}
.card-actions {
  position: absolute;
  bottom: 0;
}
</style>